import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Button, notification } from "antd";
import { saveAs } from "file-saver";

import driversActions from "../../../redux/drivers/actions";
import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import { formatDriversTurnOverResponse } from "./FormatDriversTurnOverResponse";
import "./index.css";

const { getDrivers, getOrderInfoByDrivers } = driversActions;
const { Option } = Select;

const OrdersActions = () => {
  const dispatch = useDispatch();
  const [selectedDrivers, setSelectedDrivers] = useState(["all"]);
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
  } = useProjectState();

  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { drivers, driversTurnOver } = useSelector(
    (state) => state.driversReducer
  );

  let filteredIds = [];
  if (selectedDrivers.includes("all")) {
    filteredIds = drivers.map((item) => item.id);
  } else {
    filteredIds = selectedDrivers.map((name) => {
      const driver = drivers.find((item) => item.name === name);
      return driver ? driver.id : null;
    });
  }

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    dispatch(getDrivers(defaultOrganization[0]?.defaultTouchSaleRestaurantId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  const firstSelectedDrivers = selectedDrivers[0];
  useEffect(() => {
    const timer = setTimeout(() => {
      if (filteredIds.length !== 0) {
        dispatch(getOrderInfoByDrivers(filteredIds, startDate, endDate));
      }
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    startDate,
    endDate,
    filteredIds.length,
    drivers.length,
    firstSelectedDrivers,
  ]);

  const handleOnChangeRestaurant = (restaurant) => {
    setAllSelectedRestaurants([restaurant]);
    dispatch(getDrivers(restaurant));
  };

  const handleOnSelectDrivers = (driver) => {
    if (driver === "all") {
      setSelectedDrivers([driver]);
    } else if (selectedDrivers.includes("all")) {
      setSelectedDrivers([driver]);
    } else {
      setSelectedDrivers((prevSelectedDrivers) => [
        ...prevSelectedDrivers,
        driver,
      ]);
    }
  };

  const handleDeSelectDriver = (driverToRemove) => {
    setSelectedDrivers((prevSelectedDrivers) => {
      return prevSelectedDrivers.filter(
        (driver) => !driverToRemove.includes(driver)
      );
    });
  };

  const newArray = formatDriversTurnOverResponse(driversTurnOver);

  const exportToExcel = () => {
    if (!newArray || newArray.length === 0) {
      notification.error({
        message: "Грешка",
        description: "Няма налични данни за експорт.",
      });
      return;
    }

    const xlsx = require("better-xlsx");
    const file = new xlsx.File();
    const sheet = file.addSheet("Sheet1");

    // Adjust column widths
    const colWidths = [10, 20, 10, 12, 12, 10, 10, 15, 12];
    colWidths.forEach((width, index) => {
      const col = sheet.col(index);
      col.width = width; // Set column width
    });

    // Add Header Row
    const headerRow = sheet.addRow();
    const headers = [
      "Номер",
      "Получена",
      "Открита",
      "Изпълнена",
      "Назначена",
      "Закрита",
      "Резултат",
      "Общо време",
      "Разстояние",
    ];
    headers.forEach((header) => {
      const cell = headerRow.addCell();
      cell.value = header;

      // Apply gray background and center alignment to header cells
      cell.style.align.h = "center";
      cell.style.align.v = "center"; // Optional for vertical alignment
      cell.style.border.top = "thin";
      cell.style.border.left = "thin";
      cell.style.border.bottom = "thin";
      cell.style.border.right = "thin";
      cell.style.fill.patternType = "solid";
      cell.style.fill.fgColor = "CCCCCC"; // Light gray color
      cell.style.font.bold = true; // Bold text
    });

    // Add Data Rows
    newArray.forEach((row) => {
      const dataRow = sheet.addRow();
      [
        row.tableNumber,
        row.accepted,
        row.created,
        row.executed,
        row.moved,
        row.closed,
        row.result,
        row.totalTime,
        row.distanceBetweenLocationsInMeters.toFixed(2),
      ].forEach((value) => {
        const cell = dataRow.addCell();
        cell.value = value !== undefined ? value.toString() : "-";

        // Center-align data cells
        cell.style.align.h = "center";
        cell.style.align.v = "center"; // Optional for vertical alignment
      });
    });

    // Save the File
    file.saveAs("blob").then(function (content) {
      const filename =
        "Справка изпълнение на доставки - " +
        localStorage.getItem("organization") +
        ".xlsx";
      saveAs(content, filename);
    });
  };

  return (
    <>
      <div className="drivers-info-action-buttons-container">
        {defaultOrganization[0]?.multipleRestaurants && (
          <Select
            showSearch={false}
            virtual={false}
            key="driversInfoRestaurantSelect"
            placeholder="Изберете ресторант"
            onChange={handleOnChangeRestaurant}
            value={allSectedRestaurants}
            className="drivers-info-action-buttons"
          >
            {restaurants?.map((restaurant) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="drivers-info-select-option"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        )}
        <DatePickerComponent limitationValue={1} limitationType={"month"} />
        <div>
          <Button
            style={{
              width: "250px",
              backgroundColor: "#33c481",
              color: "white",
            }}
            onClick={exportToExcel}
          >
            Експорт към Excel
          </Button>
        </div>
      </div>
      <div className="drivers-info-select-container">
        <Select
          disabled={allSectedRestaurants[0] === undefined}
          virtual={false}
          key="salesInfodriverselect"
          mode="multiple"
          placeholder="Изберете сервитьори"
          onSelect={handleOnSelectDrivers}
          onDeselect={handleDeSelectDriver}
          value={selectedDrivers}
          maxTagCount={6}
          className="drivers-info-select-drivers"
        >
          <Option key="all" value="all">
            Всички
          </Option>
          {drivers &&
            drivers.map((driver) => (
              <Option key={driver.name} value={driver.name}>
                {driver.name}
              </Option>
            ))}
        </Select>
      </div>
    </>
  );
};

export default OrdersActions;
